module.exports = __webpack_public_path__ + "img/zsgg-9.3047af7a.png";